import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProbableSource, getSiteMaintenanceData, getWindRoseData, saveMaintenanceData, GetSoofieUptimeExport, getKMLDownloadData } from "../../config/services/ApiServices";
import { getSiteConfigurationHistory, getWorkorderHistory, getConfigurationTable, getSiteHistoryUptimeReport } from "../../config/services/ApiServices";
import { GetSoofieUptimeGlobal, GetAsset, GetGroundDataDetails,getSiteReprocess,getRegenerateBilling ,getAnomalySoofieTimeseriesData,getSites, getEquipmentAndDevices,getAIAnomalySoofie,getOneHourAverage} from "../../config/services/ApiServices";

export const fetchProbableSourceChart = createAsyncThunk('probablesource-chart/fetch', async ({ startDate, endDate, customerId, timeZone, assetId }: { startDate: Date, endDate: Date, customerId: string, timeZone?: any, assetId?: string, }) => {
  const response = await getProbableSource({ startDate, endDate, customerId, timeZone, assetId });
  return response;
})

export const fetchSiteConfigurationHistory = createAsyncThunk('SiteConfigurationHistory-table/fetch', async ({ startDate, endDate, customerId, timeZone, assetId }: { startDate: Date, endDate: Date, customerId: string, timeZone?: any, assetId?: string, }) => {
  const response = await getSiteConfigurationHistory({ startDate, endDate, customerId, timeZone, assetId });
  return response;
})

export const fetchWorkorderHistory = createAsyncThunk('WorkorderHistory-table/fetch', async ({ startDate, endDate, customerId, timeZone, assetId }: { startDate: Date, endDate: Date, customerId: string, timeZone?: any, assetId?: string, }) => {
  const response = await getWorkorderHistory({ startDate, endDate, customerId, timeZone, assetId });
  return response;
})

export const fetchWindRoseData = createAsyncThunk('windRose-chart/fetch', async ({ startDate, endDate, customerId, assetId }: { startDate: Date, endDate: Date, customerId: string, assetId?: string, }) => {
  const response = await getWindRoseData({ startDate, endDate, customerId, assetId });
  return response;
})

export const fetchConfigurationTable = createAsyncThunk('ConfigurationTable-table/fetch', async ({ customerId, assetId }: { customerId: string, assetId?: string, }) => {
  const response = await getConfigurationTable({ customerId, assetId });
  // return jsonData;
  return response;
})

export const fetchSiteMaintenanceTable = createAsyncThunk('maintenace-table/fetch', async ({ startDate, endDate, customerId, assetId }: { startDate: Date, endDate: Date, customerId: string, assetId: string, }) => {
  const response = await getSiteMaintenanceData({ startDate, endDate, customerId, assetId });
  return response;
})

export const saveMaintenanceDataThunk = createAsyncThunk(
  'maintenance-table/saveMaintenanceData',
  async ({ siteId, custId, date, userName, deviceName, activity }: { siteId: string, custId: string, date: string, userName: string, deviceName: string, activity: string }) => {
    try {
      const response = await saveMaintenanceData({ siteId, custId, date, userName, deviceName, activity });
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchSiteHistoryUptimeReport = createAsyncThunk('siteHistoryUptimeReport-table/fetch', async ({ startTime, endTime, customerId, isPercent, siteId }: { startTime: Date, endTime: Date, customerId: string, isPercent?: any, siteId?: string, }) => {
  const response = await getSiteHistoryUptimeReport({ customerId, siteId, startTime, endTime, isPercent });
  return response;
})

export const fetchSoofieUptimeExport = createAsyncThunk('SoofieUptimeExport-download/fetch', async ({ StartTime, EndTime, CustomerId, SiteId }: { StartTime: Date, EndTime: Date, CustomerId: any, SiteId?: any, }) => {
  const response = await GetSoofieUptimeExport({ CustomerId, SiteId, StartTime, EndTime });
  return response;
})

export const fetchSoofieUptimeGlobal = createAsyncThunk('SoofieUptimeGlobal-table/fetch', async ({ StartTime, EndTime, CustomerId, isPercent, SiteIds }: { StartTime: Date, EndTime: Date, CustomerId: string, isPercent?: any, SiteIds?: any, }) => {
  const response = await GetSoofieUptimeGlobal({ customerId: CustomerId, siteIds: SiteIds, startTime: StartTime, endTime: EndTime, isPercent });

  return response;
})

export const fetchGroundDataDetail = createAsyncThunk('GroundDataDetail-table/fetch', async ({ startTime, endTime, customerId, deviceId, siteIds }: { startTime: Date, endTime: Date, customerId: string, deviceId?: any, siteIds?: any, }) => {
  const response = await GetGroundDataDetails({ customerId, siteIds, startTime, endTime, deviceId });

  return response;
})

export const fetchCustomerAsset = createAsyncThunk('GetAsset-table/fetch', async ({ customerId }: { customerId: string }) => {
  const response = await GetAsset({ customerId });
  return response;
})

export const fetchSiteReprocess = createAsyncThunk('SiteReprocess-table/fetch', async ({ customerIds,siteIds,startDate,endDate }: 
  { customerIds: any[]; siteIds: any[]; startDate: string;endDate: string; }) => {

  const response = await getSiteReprocess({ customerIds, siteIds, startDate, endDate });

  return response;
})

export const fetchRegenerateBilling = createAsyncThunk('RegenerateBilling-table/fetch', async ({ customerIds, month }: 
  { customerIds: any[];  month: string;}) => {
  const response = await getRegenerateBilling({ customerIds, month });
  return response;
})

export const fetchAnomalySoofieTimeseries = createAsyncThunk('AnomalySoofieTimeseries-graph/fetch', async ({timeRange,urlData}: 
  { timeRange : any,urlData: any;}) => {

  const response = await getAnomalySoofieTimeseriesData({ timeRange, urlData});

  return response;
})

export const fetchAIAnomalyTable = createAsyncThunk('AIAnomalyTable/fetch', async ({ StartDate, EndDate, AssetId}: {
  StartDate: string; EndDate: string; AssetId: string;}) => {

  const response = await getAIAnomalySoofie({ StartDate, EndDate,AssetId});

  return response;
})

export const fetchSiteList = createAsyncThunk('SiteList-graph/fetch', async (customerId: string) => {
  const response = await getSites( customerId);
  return response;
})

export const fetchEquipmentAndDevices = createAsyncThunk('GetEquipments/fetch', async (siteId: string) => {
  const response = await getEquipmentAndDevices( siteId);
  return response;
})

export const fetchOneHourAverage = createAsyncThunk('OneHourAverage/fetch', async ({ siteId,startTime, endTime, }: {
  siteId: string;   startTime: string; endTime: string;}) => {

  const response = await getOneHourAverage({ siteId,startTime ,endTime,});

  return response;
})

export const fetchKMLDownloadData = createAsyncThunk('DownloadKML-data/fetch',async ({siteId,emissionDevices,emission,siteName,windDirection,windSpeed,windDirectionDeviation,siteLength,}: {
    siteId: string;emissionDevices: string[];emission: number;siteName: string;windDirection: number;windSpeed: number;windDirectionDeviation: number;siteLength: number;
  }) => {
    const response = await getKMLDownloadData({siteId,emissionDevices,emission,siteName,windDirection,windSpeed,windDirectionDeviation,siteLength,});
    return response;
  }
);